export const MARKETING_URL = 'https://supplychainvaluecreator.com'

/**
 * Where every unauthenticated or unknown location goes, exactly as the Vue
 * router's two guards sent it: a full navigation off the SPA, not a route.
 */
export function leaveToMarketingSite() {
  window.location.href = MARKETING_URL
}
